/** Status der mandantenweiten Internet-Master-Schalter (GET/PUT /api/mandant/internet). */
export interface InternetStatus {
  websuche_erlaubt: boolean;
  github_tickets_erlaubt: boolean;
  websuche_moeglich: boolean;
  github_konfiguriert: boolean;
}

export type SchalterKey = 'websuche' | 'github';

export interface SchalterZustand {
  checked: boolean;
  disabled: boolean;
  hinweis: string | null;
}

/** Leitet Zustand und Hinweistext eines Schalters ab.
    Nicht-Admins sehen nur den Status: "aus" bei ausgeschaltetem Master-Schalter,
    "an" bei eingeschaltetem Master und eigenem Recht (faehigkeit.websuche bzw.
    faehigkeit.github_tickets = JA), sonst "nicht freigegeben". Admins können einschalten, wenn die
    Funktion technisch möglich ist; Ausschalten ist immer erlaubt, damit ein
    Schalter nie "hängen bleibt" (z.B. Token entfernt, Anbieter gewechselt). */
export function schalterZustand(
  s: InternetStatus, key: SchalterKey, istAdmin: boolean,
  eigenesRecht: boolean = false,
): SchalterZustand {
  const checked = key === 'websuche' ? s.websuche_erlaubt : s.github_tickets_erlaubt;
  if (!istAdmin) {
    return { checked, disabled: true, hinweis: !checked ? 'aus' : eigenesRecht ? 'an' : 'nicht freigegeben' };
  }
  if (key === 'github' && !s.github_konfiguriert) {
    return { checked, disabled: !checked, hinweis: 'nicht konfiguriert' };
  }
  if (key === 'websuche' && !s.websuche_moeglich) {
    return { checked, disabled: !checked, hinweis: 'mit aktuellem KI-Anbieter nicht verfügbar' };
  }
  return { checked, disabled: false, hinweis: null };
}
